export const sortOrderOptions = [
  ["none", "Padrão"],
  ["number-asc", "Número crescente"],
  ["number-desc", "Número decrescente"],
  ["fare-asc", "Tarifa crescente"],
  ["fare-desc", "Tarifa decrescente"],
  // ["active-lines-asc", "Linha em atividade (crescente)"],
  ["company-asc", "Companhia crescente"],
  ["company-desc", "Companhia decrescente"],
];

export const isMetropolitanOptions = [
  ["", "Todas"],
  ["yes", "Metropolitana"],
  ["no", "Municipal"],
];
